import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { isDefinedString } from "et3-type-guards";
import { fontWeights } from "et3-ui-library";
import i18n, { Ti18nKeys } from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import PictureStatusIcon from "../../../../core/et3-pop-up-album/PictureStatusIcon";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";

const KhattabatUserDescriptionCard = withLiteObserverAndTheme<{
  titleKey: Ti18nKeys;
  description: string;
  descriptionStatus: string;
  alignment: "left" | "right";
}>((props) => {
  const { titleKey, description, descriptionStatus, alignment } = props;
  const { getDescriptionTone, getDescriptionHighlight } =
    getUserAdvancedStore();
  const { borderColor, statusImage } = getDescriptionTone(descriptionStatus);

  return (
    <Paper variant="outlined" sx={{ p: 1.5, borderColor, borderWidth: 2 }}>
      <Stack spacing={1}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography fontWeight={fontWeights.semibold}>
            {i18n.get(titleKey)}
          </Typography>
          {isDefinedString(description) ? (
            <PictureStatusIcon statusImage={statusImage} />
          ) : null}
        </Stack>
        <Typography
          variant="body2"
          sx={{
            ...getDescriptionHighlight(description),
            textAlign: alignment,
            whiteSpace: "pre-wrap",
            maxHeight: 200,
            overflowY: "auto",
            borderRadius: 1,
            p: 1
          }}
        >
          {description}
        </Typography>
      </Stack>
    </Paper>
  );
});

export default KhattabatUserDescriptionCard;
